import React, { useState } from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import Breadcrumb from "../../components/Breadcrumb";
import WishListSection from "../../components/WishListSection";
import ShippingOne from "../../components/ShippingOne";
import BottomFooter from "../../components/BottomFooter";
import HeaderOne from "../../components/HeaderOne";
import FooterOne from "../../components/FooterOne";

function WishlistPage() {
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("selectedCurrency")
  );

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      {/* <ScrollToTop smooth color='#1E293B' /> */}

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"My Wishlist"} />

      {/* WishListSection */}
      <WishListSection selectedCurrency={selectedCurrency} />

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      {/* <BottomFooter /> */}
    </>
  );
}

export default WishlistPage;
